module.exports = __webpack_public_path__ + "static/media/soap.905e2cd8.jpg";